import { authFetch } from "~/services/fetch";

export interface UserOccurrenceActionsParams {
  readonly user_id?: number
  readonly dispatch_id?: number
  readonly station_id?: number| null
  readonly origin?: string | null
  readonly device_id: number | null
  readonly start_date: string
  readonly finish_date: string
  readonly page?: number
  readonly limit?: number
  readonly orders?: readonly { readonly field: string; readonly sort: string }[]
}

export interface UserAction {
  readonly id?: number
  readonly station?: string
  readonly user_name?: string
  readonly detail?: string
  readonly action_type?: string
  readonly search_info?: unknown
  readonly created_at?: string
  readonly device?: string
}

export interface UserActionsResponse {
  readonly data: readonly UserAction[]
  readonly rowsCount: number
}

export async function getUserActionsSearchLogs(params: UserOccurrenceActionsParams): Promise<UserActionsResponse> {
    const { orders, ...otherParams } = params
    const response = await authFetch({
        url: '/user/occurrence-actions',
        method: 'POST',
        data: {
            ...otherParams,
            orders: orders || [{ "field": "created_at", "sort": "desc" }]
        }
    })

    return response.data
}